export default "__VITE_ASSET__BIFIC0Sq__"